let transferIndex = 0
let lastVisibleIndex = 0

function lastVisibleIncrease() {
  lastVisibleIndex++
}

export { transferIndex, lastVisibleIndex, lastVisibleIncrease }
